import { useState } from "react";

import SearchField from "app/components/shared/SearchField";
import { Skeleton } from "app/components/shared/Skeleton";
import { Example, useExamples } from "app/components/shared/Examples/useExamples";

import { ExampleDetail } from "./ExampleDetail";
import { ExamplesList } from "./ExamplesList";
import { times } from "lodash";

export default function Examples({ examplesPath }: { examplesPath: string }) {
  const [selectedExample, setSelectedExample] = useState<Example | null>(null);

  const { examples, loading, error, query, setQuery } = useExamples(examplesPath);

  function clearExample() {
    setSelectedExample(null);
  }

  if (selectedExample) {
    return <ExampleDetail example={selectedExample} onBack={clearExample} />;
  }

  return (
    <>
      <div className="border-b border-gray px-3 py-2">
        <SearchField
          autofocus={!!query}
          className="[&_input]:h-8"
          onChange={setQuery}
          searching={loading}
          defaultValue={query}
        />
      </div>

      {(() => {
        if (loading && !examples?.length) {
          return (
            <div className="grid gap-2.5 p-3">
              {times(8, (index) => (
                <Skeleton key={index} className="h-[32px] w-full" />
              ))}
            </div>
          );
        }

        if (!loading && !examples?.length) {
          return (
            <p className="m-0 p-3 text-charcoal-300">
              No examples{query && ` matching “${query}”`}.
            </p>
          );
        }

        if (error || !examples) {
          return (
            <p className="m-0 p-3">
              There was a problem loading examples, please try reloading the page. If the problem
              persists please contact support.
            </p>
          );
        }

        return <ExamplesList examples={examples} onSelect={setSelectedExample} />;
      })()}
    </>
  );
}
